import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/atoms";

const STORAGE_KEY = "drb_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-night-blue/10 bg-white px-4 py-4 shadow-lg sm:bottom-4 sm:left-4 sm:right-auto sm:max-w-sm sm:rounded-card sm:border"
    >
      <button
        onClick={decline}
        className="absolute right-3 top-3 text-night-blue/70 hover:text-night-blue"
        aria-label="Close"
      >
        <X size={16} />
      </button>
      <p className="pr-6 text-sm text-night-blue/80">
        We use cookies to improve your experience and remember your cart.{" "}
        <Link
          to="/legal/privacy"
          className="font-medium text-healthy-blue underline"
        >
          Privacy Policy
        </Link>
      </p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={accept}>
          Accept
        </Button>
        <Button size="sm" variant="outline" onClick={decline}>
          Decline
        </Button>
      </div>
    </div>
  );
}
